import { Component, OnInit, Output, EventEmitter, Input, Inject } from '@angular/core';
import {SelectItem} from 'primeng/api';

import { Subscription } from 'rxjs';
import { Project } from '../../../features/project/models/project';
import { MenuBehaviorSubjectService } from '../../../shared/services/menu-behavior-subject.service';
import { CookieService } from 'ngx-cookie-service';
import { MonitoringBehaviorSubjectService } from '../../../features/monitoring/services/monitoring-behavior-subject.service';
import { ConfigurationDataService } from '../../../features/configurations/services/configuration-data.service';
import { StateService } from '@uirouter/core';


@Component({
  selector: 'app-project-menu',
  template: require('./project-menu.component.html'),
  styles: [require('./project-menu.component.sass')]
})
export class ProjectMenuComponent implements OnInit {
  
  @Input() projects: Project[]; 
  projectGroups: Array<SelectItem> = [];

  defaultProject: Project | undefined;
  
  projectId: number;

  public selectedOptions: Array<SelectItem> = new Array<SelectItem>();
  public selectedItemsLabel = 'Choose';

  menuChangeSubscription: Subscription;

  @Output() onPanelHide: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    @Inject('ProjectService') private projectService: any,
    @Inject('ConfigurationStoreService') private configurationStoreService: any,
    private menuBehaviorSubjectService: MenuBehaviorSubjectService,
    private monitoringBehaviorSubjectService: MonitoringBehaviorSubjectService,
    private cookieService: CookieService,
    private configurationDataService: ConfigurationDataService,
    private stateService: StateService
  ) { 
      this.menuChangeSubscription = this.menuBehaviorSubjectService.changeOccured.subscribe((data) => {
        if (data) {
          switch (data.action) {
            case 'menu-changed':
              this.projectId = data.parameter && parseInt(data.parameter);
              this._setDefaultProject(this.projectId);
              if (this.projectId === 0) {
                this._configureICprojectsMenu();
              }
            break;
          }
        }
      })
  }

  ngOnInit() {
    this.projectId = this.stateService.params && parseInt(this.stateService.params.projectId);
    this.defaultProject = undefined;
    this._setDefaultProject();
    if (this.projectId === 0) {
      this._configureICprojectsMenu();
    }

    const configPromises = this.projects.map(project => this.configurationDataService.getProjectConfiguration(project.id).toPromise())
    Promise.all(configPromises).then(configs => {
      this.configurationStoreService.setActiveProjectConfigurations(configs);
    })
  }

  private _setDefaultProject = (projectId?: number) => {
    let defaultProjectId = this.cookieService.get('nomad.noc.ng.defaultProjectId');
    if (projectId && (projectId > 0) && (projectId !== parseInt(defaultProjectId))){
      defaultProjectId = projectId.toString();
      this.cookieService.set('nomad.noc.ng.defaultProjectId', defaultProjectId.toString());
    }
    this.defaultProject = this.projects && this.projects.find(project => project.id === (defaultProjectId ? parseInt(defaultProjectId) : 1));
  }

  private _configureICprojectsMenu = () => {
    const projectEntities = this.projects && this.projects.reduce((acc, project) => {
      project.region = project.region || 'N/A';
      if (!acc[project.region]) {
        acc[project.region] = {
          label: project.region,
          value: {
            label: project.region,
            childOptions: [],
            selectedChildOptions: []
          }
        }
      }
      acc[project.region]['value']['childOptions'] = [
        ...acc[project.region]['value']['childOptions'],
        {
          label: project.name,
          id: project.id,
          value: {
            label: project.name,
            id: project.id,
            childOptions: []
          }
        },
      ]
      return acc;
    }, {});
    const selectedProjectIds =  this.cookieService.get('nomad.noc.ng.projects');
    var arraySelectedIds = selectedProjectIds ? (selectedProjectIds.toString().includes('-') ? selectedProjectIds.split('-') : [selectedProjectIds]) : [];
    this.projectGroups = projectEntities && Object.keys(projectEntities).map(region => {
      projectEntities[region]['value'] = {
        ...projectEntities[region]['value'],
        selectedChildOptions: projectEntities[region]['value'].childOptions.reduce((acc,childOption) => {
            acc[childOption.id] = !!arraySelectedIds.find(id => parseInt(id) === childOption.id);
            return acc;
        }, {}),
      } 
     return {
       ...projectEntities[region],
       childProjects: projectEntities[region].value.childOptions.reduce((acc, option) => {
          return acc ? acc + ',' + option.label : option.label
       }, '')
     }
    });
  }

  onChangeDefaultProject = () => {
    if (this.defaultProject) {
      this.projectService.setSelectedProjectById(this.defaultProject.id, "MENU");
      this.cookieService.set('nomad.noc.ng.defaultProjectId', this.defaultProject.id.toString());
    }
  }

  onSelectedChange = (options: any[]) => {
    const selectedProjectIds = options && options.reduce((acc, option) => {
       return Object.keys(option.value.selectedChildOptions)
                                      .filter(projectId => !!option.value.selectedChildOptions[projectId])
                                      .reduce((accLabel, projectId) => accLabel ? accLabel + '-' + projectId : projectId, acc);
    }, '')
    this.cookieService.set('nomad.noc.ng.projects', selectedProjectIds);
    this.monitoringBehaviorSubjectService.inform('reload-trains', false);
    this.menuBehaviorSubjectService.inform("project-menu-changed", selectedProjectIds)
  }

}
